import { default as aboutJQppuo1Ec4Meta } from "/tmp/build_b474bb5e/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue?macro=true";
import { default as eventsSMNIHk4oIvMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_934vnT9j5OszMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45samples5m468CaMHMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productsm8tgF4xXFDMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93FSI07CnKd3Meta } from "/tmp/build_b474bb5e/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as viewO1uAYgxyHiMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as indexqTjo3i7vK3Meta } from "/tmp/build_b474bb5e/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_93IAdZ4b1kwZMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexhaYhf2rdcPMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93rkFfZjCOO9Meta } from "/tmp/build_b474bb5e/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexgLMs3lL3RoMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionswcQ83jBAHnMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordings5Da2XfdyWtMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue?macro=true";
import { default as reviewszZ3WsIOFZ5Meta } from "/tmp/build_b474bb5e/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_93BzgGfAN5CtMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue?macro=true";
import { default as indexEaE3lwZxHuMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/buy/product/[product_id]/index.vue?macro=true";
import { default as confirmFUSrfBueKdMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue?macro=true";
import { default as confirmDVzSBC6KACMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue?macro=true";
import { default as calendaro0qQw1QPllMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/calendar.vue?macro=true";
import { default as chatkQYJf3OsmqMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/chat.vue?macro=true";
import { default as aboutjKQuGcN4txMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/community-groups/[group_id]/about.vue?macro=true";
import { default as feedDWAiDs2AfVMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/community-groups/[group_id]/feed.vue?macro=true";
import { default as membersuPAWzWY8pIMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/community-groups/[group_id]/members.vue?macro=true";
import { default as _91group_id_93ZgzgfbouBIMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/community-groups/[group_id].vue?macro=true";
import { default as community_45profile_45editbz0EXi0hEdMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/community-profile-edit.vue?macro=true";
import { default as _91id_93Dv5fHn4v70Meta } from "/tmp/build_b474bb5e/pages/[studio_url]/community-profile/[id].vue?macro=true";
import { default as communityUy1j4YNuPzMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/community.vue?macro=true";
import { default as _91uuid_93CMbjhSp6JdMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/complete-registration/[uuid].vue?macro=true";
import { default as _91unique_id_93fuo33HKlUgMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/contracts/[unique_id].vue?macro=true";
import { default as dashboardjB5ZInK21rMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/dashboard.vue?macro=true";
import { default as indexaZMy4tpKUfMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/event/details/[event_id]/index.vue?macro=true";
import { default as checkout3x7xh0p9KXMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue?macro=true";
import { default as select_45productsWkfsCROvWMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/event/details/[event_id]/select-product.vue?macro=true";
import { default as eventsTX1gPiuccgMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/events.vue?macro=true";
import { default as _91uuid_937xTkGSzaVzMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/gifts/[uuid].vue?macro=true";
import { default as indexM8sKxDRuhIMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/gifts/index.vue?macro=true";
import { default as _91invitation_id_93xkmpdqdsLeMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/gifts/invitation/[invitation_id].vue?macro=true";
import { default as _91product_id_93gKYlISYQrQMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/gifts/product/[product_id].vue?macro=true";
import { default as indexTkqcjnIFITMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/index.vue?macro=true";
import { default as _91invitation_unique_id_93S0jMQ8CMWFMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/invitation/[invitation_unique_id].vue?macro=true";
import { default as jointhIZfvlFToMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/join.vue?macro=true";
import { default as login0jfX7z218ZMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/login.vue?macro=true";
import { default as logoutuflFQqDTObMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/logout.vue?macro=true";
import { default as _91meeting_type_slug_93rIBVUyjY81Meta } from "/tmp/build_b474bb5e/pages/[studio_url]/meet/[meeting_type_slug].vue?macro=true";
import { default as _91meeting_unique_id_93o5Ivt80scyMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/meet/[meeting_unique_id].vue?macro=true";
import { default as _91meeting_unique_id_93qOCA07HOi9Meta } from "/tmp/build_b474bb5e/pages/[studio_url]/meeting/[meeting_unique_id].vue?macro=true";
import { default as my_45favoritestaZ5Fon6RfMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/my-favorites.vue?macro=true";
import { default as my_45studios2gnOwCjDO1Meta } from "/tmp/build_b474bb5e/pages/[studio_url]/my-studios.vue?macro=true";
import { default as optindDk4frOM3oMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/optin.vue?macro=true";
import { default as _91episode_id_93lbkf0yt0Y4Meta } from "/tmp/build_b474bb5e/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue?macro=true";
import { default as indexZToqwTH4fUMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/podcasts/[podcast_id]/index.vue?macro=true";
import { default as indexOFJrtRce57Meta } from "/tmp/build_b474bb5e/pages/[studio_url]/podcasts/index.vue?macro=true";
import { default as aboutPXwGvGGbkLMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/product/[product_id]/about.vue?macro=true";
import { default as digital_45download_45contentGntyhLgZMtMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/product/[product_id]/digital-download-content.vue?macro=true";
import { default as eventskDb9e4c5MoMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93GvcxzlqaHLMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45samplePMiDqn6KHEMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productsB4OB4d1oRaMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93UJ6B4ypE9EMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as viewkyMsNf5sZiMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as indexNIHAoAntPKMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_932tqWuG1IrfMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexASy0KRozOcMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_937jhV6u2nXXMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as index97zoCuOjT2Meta } from "/tmp/build_b474bb5e/pages/[studio_url]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionsnqJ32pSu2QMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordingsuBUJxJZv9xMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/product/[product_id]/recordings.vue?macro=true";
import { default as reviewsYzbroVUc78Meta } from "/tmp/build_b474bb5e/pages/[studio_url]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_93FIv2MB8KHOMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/product/[product_id].vue?macro=true";
import { default as indexhxnHqJb2NlMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/product/index.vue?macro=true";
import { default as indexd17aMwC1kwMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/profile/index.vue?macro=true";
import { default as purchasesvludfOEvMhMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/profile/purchases.vue?macro=true";
import { default as redemptions21Q7nH4Z3wMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/profile/redemptions.vue?macro=true";
import { default as _91quiz_id_93RLeVdeUs6KMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/quiz/[quiz_id].vue?macro=true";
import { default as _91token_93HVvdm1Lb0JMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/reset-password/[uid]/[token].vue?macro=true";
import { default as resetXF04AmUbT4Meta } from "/tmp/build_b474bb5e/pages/[studio_url]/reset.vue?macro=true";
import { default as shopGoRKx11DJOMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/shop.vue?macro=true";
import { default as signupPtfzKoRYGAMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/signup.vue?macro=true";
import { default as livejL8wToAidkMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/streaming/[event_id]/live.vue?macro=true";
import { default as tipsFjKnTlna3cMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/tips.vue?macro=true";
import { default as _91uuid_933HoC85NHt8Meta } from "/tmp/build_b474bb5e/pages/[studio_url]/waiver/[uuid].vue?macro=true";
import { default as compactRCI1dybz3sMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/widgets/calendars/compact.vue?macro=true";
import { default as fullU6Wi9H9mtcMeta } from "/tmp/build_b474bb5e/pages/[studio_url]/widgets/calendars/full.vue?macro=true";
export default [
  {
    name: _91product_id_93BzgGfAN5CtMeta?.name ?? "bundle-bundle_id-product-product_id",
    path: _91product_id_93BzgGfAN5CtMeta?.path ?? "/bundle/:bundle_id()/product/:product_id()",
    meta: _91product_id_93BzgGfAN5CtMeta || {},
    alias: _91product_id_93BzgGfAN5CtMeta?.alias || [],
    redirect: _91product_id_93BzgGfAN5CtMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutJQppuo1Ec4Meta?.name ?? "bundle-bundle_id-product-product_id-about",
    path: aboutJQppuo1Ec4Meta?.path ?? "about",
    meta: aboutJQppuo1Ec4Meta || {},
    alias: aboutJQppuo1Ec4Meta?.alias || [],
    redirect: aboutJQppuo1Ec4Meta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: eventsSMNIHk4oIvMeta?.name ?? "bundle-bundle_id-product-product_id-events",
    path: eventsSMNIHk4oIvMeta?.path ?? "events",
    meta: eventsSMNIHk4oIvMeta || {},
    alias: eventsSMNIHk4oIvMeta?.alias || [],
    redirect: eventsSMNIHk4oIvMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_934vnT9j5OszMeta?.name ?? "bundle-bundle_id-product-product_id-free-media-media_id",
    path: _91media_id_934vnT9j5OszMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_934vnT9j5OszMeta || {},
    alias: _91media_id_934vnT9j5OszMeta?.alias || [],
    redirect: _91media_id_934vnT9j5OszMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45samples5m468CaMHMeta?.name ?? "bundle-bundle_id-product-product_id-free-sample",
    path: free_45samples5m468CaMHMeta?.path ?? "free-sample",
    meta: free_45samples5m468CaMHMeta || {},
    alias: free_45samples5m468CaMHMeta?.alias || [],
    redirect: free_45samples5m468CaMHMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productsm8tgF4xXFDMeta?.name ?? "bundle-bundle_id-product-product_id-included-products",
    path: included_45productsm8tgF4xXFDMeta?.path ?? "included-products",
    meta: included_45productsm8tgF4xXFDMeta || {},
    alias: included_45productsm8tgF4xXFDMeta?.alias || [],
    redirect: included_45productsm8tgF4xXFDMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93FSI07CnKd3Meta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93FSI07CnKd3Meta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93FSI07CnKd3Meta || {},
    alias: _91media_id_93FSI07CnKd3Meta?.alias || [],
    redirect: _91media_id_93FSI07CnKd3Meta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: viewO1uAYgxyHiMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-view",
    path: viewO1uAYgxyHiMeta?.path ?? "lessons/:lesson_id()/view",
    meta: viewO1uAYgxyHiMeta || {},
    alias: viewO1uAYgxyHiMeta?.alias || [],
    redirect: viewO1uAYgxyHiMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: indexqTjo3i7vK3Meta?.name ?? "bundle-bundle_id-product-product_id-lessons",
    path: indexqTjo3i7vK3Meta?.path ?? "lessons",
    meta: indexqTjo3i7vK3Meta || {},
    alias: indexqTjo3i7vK3Meta?.alias || [],
    redirect: indexqTjo3i7vK3Meta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93IAdZ4b1kwZMeta?.name ?? "bundle-bundle_id-product-product_id-media-media_id",
    path: _91media_id_93IAdZ4b1kwZMeta?.path ?? "media/:media_id()",
    meta: _91media_id_93IAdZ4b1kwZMeta || {},
    alias: _91media_id_93IAdZ4b1kwZMeta?.alias || [],
    redirect: _91media_id_93IAdZ4b1kwZMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexhaYhf2rdcPMeta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id",
    path: indexhaYhf2rdcPMeta?.path ?? "playlists/:playlist_id()",
    meta: indexhaYhf2rdcPMeta || {},
    alias: indexhaYhf2rdcPMeta?.alias || [],
    redirect: indexhaYhf2rdcPMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93rkFfZjCOO9Meta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93rkFfZjCOO9Meta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93rkFfZjCOO9Meta || {},
    alias: _91media_id_93rkFfZjCOO9Meta?.alias || [],
    redirect: _91media_id_93rkFfZjCOO9Meta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexgLMs3lL3RoMeta?.name ?? "bundle-bundle_id-product-product_id-playlists",
    path: indexgLMs3lL3RoMeta?.path ?? "playlists",
    meta: indexgLMs3lL3RoMeta || {},
    alias: indexgLMs3lL3RoMeta?.alias || [],
    redirect: indexgLMs3lL3RoMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionswcQ83jBAHnMeta?.name ?? "bundle-bundle_id-product-product_id-private-sessions",
    path: private_45sessionswcQ83jBAHnMeta?.path ?? "private-sessions",
    meta: private_45sessionswcQ83jBAHnMeta || {},
    alias: private_45sessionswcQ83jBAHnMeta?.alias || [],
    redirect: private_45sessionswcQ83jBAHnMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordings5Da2XfdyWtMeta?.name ?? "bundle-bundle_id-product-product_id-recordings",
    path: recordings5Da2XfdyWtMeta?.path ?? "recordings",
    meta: recordings5Da2XfdyWtMeta || {},
    alias: recordings5Da2XfdyWtMeta?.alias || [],
    redirect: recordings5Da2XfdyWtMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviewszZ3WsIOFZ5Meta?.name ?? "bundle-bundle_id-product-product_id-reviews",
    path: reviewszZ3WsIOFZ5Meta?.path ?? "reviews",
    meta: reviewszZ3WsIOFZ5Meta || {},
    alias: reviewszZ3WsIOFZ5Meta?.alias || [],
    redirect: reviewszZ3WsIOFZ5Meta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexEaE3lwZxHuMeta?.name ?? "buy-product-product_id",
    path: indexEaE3lwZxHuMeta?.path ?? "/buy/product/:product_id()",
    meta: indexEaE3lwZxHuMeta || {},
    alias: indexEaE3lwZxHuMeta?.alias || [],
    redirect: indexEaE3lwZxHuMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/buy/product/[product_id]/index.vue").then(m => m.default || m)
  },
  {
    name: confirmFUSrfBueKdMeta?.name ?? "buy-product-product_id-paypal-confirm",
    path: confirmFUSrfBueKdMeta?.path ?? "/buy/product/:product_id()/paypal/confirm",
    meta: confirmFUSrfBueKdMeta || {},
    alias: confirmFUSrfBueKdMeta?.alias || [],
    redirect: confirmFUSrfBueKdMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue").then(m => m.default || m)
  },
  {
    name: confirmDVzSBC6KACMeta?.name ?? "buy-product-product_id-stripe-confirm",
    path: confirmDVzSBC6KACMeta?.path ?? "/buy/product/:product_id()/stripe/confirm",
    meta: confirmDVzSBC6KACMeta || {},
    alias: confirmDVzSBC6KACMeta?.alias || [],
    redirect: confirmDVzSBC6KACMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue").then(m => m.default || m)
  },
  {
    name: calendaro0qQw1QPllMeta?.name ?? "calendar",
    path: calendaro0qQw1QPllMeta?.path ?? "/calendar",
    meta: calendaro0qQw1QPllMeta || {},
    alias: calendaro0qQw1QPllMeta?.alias || [],
    redirect: calendaro0qQw1QPllMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/calendar.vue").then(m => m.default || m)
  },
  {
    name: chatkQYJf3OsmqMeta?.name ?? "chat",
    path: chatkQYJf3OsmqMeta?.path ?? "/chat",
    meta: chatkQYJf3OsmqMeta || {},
    alias: chatkQYJf3OsmqMeta?.alias || [],
    redirect: chatkQYJf3OsmqMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/chat.vue").then(m => m.default || m)
  },
  {
    name: _91group_id_93ZgzgfbouBIMeta?.name ?? "community-groups-group_id",
    path: _91group_id_93ZgzgfbouBIMeta?.path ?? "/community-groups/:group_id()",
    meta: _91group_id_93ZgzgfbouBIMeta || {},
    alias: _91group_id_93ZgzgfbouBIMeta?.alias || [],
    redirect: _91group_id_93ZgzgfbouBIMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/community-groups/[group_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutjKQuGcN4txMeta?.name ?? "community-groups-group_id-about",
    path: aboutjKQuGcN4txMeta?.path ?? "about",
    meta: aboutjKQuGcN4txMeta || {},
    alias: aboutjKQuGcN4txMeta?.alias || [],
    redirect: aboutjKQuGcN4txMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/community-groups/[group_id]/about.vue").then(m => m.default || m)
  },
  {
    name: feedDWAiDs2AfVMeta?.name ?? "community-groups-group_id-feed",
    path: feedDWAiDs2AfVMeta?.path ?? "feed",
    meta: feedDWAiDs2AfVMeta || {},
    alias: feedDWAiDs2AfVMeta?.alias || [],
    redirect: feedDWAiDs2AfVMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/community-groups/[group_id]/feed.vue").then(m => m.default || m)
  },
  {
    name: membersuPAWzWY8pIMeta?.name ?? "community-groups-group_id-members",
    path: membersuPAWzWY8pIMeta?.path ?? "members",
    meta: membersuPAWzWY8pIMeta || {},
    alias: membersuPAWzWY8pIMeta?.alias || [],
    redirect: membersuPAWzWY8pIMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/community-groups/[group_id]/members.vue").then(m => m.default || m)
  }
]
  },
  {
    name: community_45profile_45editbz0EXi0hEdMeta?.name ?? "community-profile-edit",
    path: community_45profile_45editbz0EXi0hEdMeta?.path ?? "/community-profile-edit",
    meta: community_45profile_45editbz0EXi0hEdMeta || {},
    alias: community_45profile_45editbz0EXi0hEdMeta?.alias || [],
    redirect: community_45profile_45editbz0EXi0hEdMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/community-profile-edit.vue").then(m => m.default || m)
  },
  {
    name: _91id_93Dv5fHn4v70Meta?.name ?? "community-profile-id",
    path: _91id_93Dv5fHn4v70Meta?.path ?? "/community-profile/:id()",
    meta: _91id_93Dv5fHn4v70Meta || {},
    alias: _91id_93Dv5fHn4v70Meta?.alias || [],
    redirect: _91id_93Dv5fHn4v70Meta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/community-profile/[id].vue").then(m => m.default || m)
  },
  {
    name: communityUy1j4YNuPzMeta?.name ?? "community",
    path: communityUy1j4YNuPzMeta?.path ?? "/community",
    meta: communityUy1j4YNuPzMeta || {},
    alias: communityUy1j4YNuPzMeta?.alias || [],
    redirect: communityUy1j4YNuPzMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/community.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93CMbjhSp6JdMeta?.name ?? "complete-registration-uuid",
    path: _91uuid_93CMbjhSp6JdMeta?.path ?? "/complete-registration/:uuid()",
    meta: _91uuid_93CMbjhSp6JdMeta || {},
    alias: _91uuid_93CMbjhSp6JdMeta?.alias || [],
    redirect: _91uuid_93CMbjhSp6JdMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/complete-registration/[uuid].vue").then(m => m.default || m)
  },
  {
    name: _91unique_id_93fuo33HKlUgMeta?.name ?? "contracts-unique_id",
    path: _91unique_id_93fuo33HKlUgMeta?.path ?? "/contracts/:unique_id()",
    meta: _91unique_id_93fuo33HKlUgMeta || {},
    alias: _91unique_id_93fuo33HKlUgMeta?.alias || [],
    redirect: _91unique_id_93fuo33HKlUgMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/contracts/[unique_id].vue").then(m => m.default || m)
  },
  {
    name: dashboardjB5ZInK21rMeta?.name ?? "dashboard",
    path: dashboardjB5ZInK21rMeta?.path ?? "/dashboard",
    meta: dashboardjB5ZInK21rMeta || {},
    alias: dashboardjB5ZInK21rMeta?.alias || [],
    redirect: dashboardjB5ZInK21rMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/dashboard.vue").then(m => m.default || m)
  },
  {
    name: indexaZMy4tpKUfMeta?.name ?? "event-details-event_id",
    path: indexaZMy4tpKUfMeta?.path ?? "/event/details/:event_id()",
    meta: indexaZMy4tpKUfMeta || {},
    alias: indexaZMy4tpKUfMeta?.alias || [],
    redirect: indexaZMy4tpKUfMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/event/details/[event_id]/index.vue").then(m => m.default || m)
  },
  {
    name: checkout3x7xh0p9KXMeta?.name ?? "event-details-event_id-product-product_id-checkout",
    path: checkout3x7xh0p9KXMeta?.path ?? "/event/details/:event_id()/product/:product_id()/checkout",
    meta: checkout3x7xh0p9KXMeta || {},
    alias: checkout3x7xh0p9KXMeta?.alias || [],
    redirect: checkout3x7xh0p9KXMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue").then(m => m.default || m)
  },
  {
    name: select_45productsWkfsCROvWMeta?.name ?? "event-details-event_id-select-product",
    path: select_45productsWkfsCROvWMeta?.path ?? "/event/details/:event_id()/select-product",
    meta: select_45productsWkfsCROvWMeta || {},
    alias: select_45productsWkfsCROvWMeta?.alias || [],
    redirect: select_45productsWkfsCROvWMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/event/details/[event_id]/select-product.vue").then(m => m.default || m)
  },
  {
    name: eventsTX1gPiuccgMeta?.name ?? "events",
    path: eventsTX1gPiuccgMeta?.path ?? "/events",
    meta: eventsTX1gPiuccgMeta || {},
    alias: eventsTX1gPiuccgMeta?.alias || [],
    redirect: eventsTX1gPiuccgMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/events.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_937xTkGSzaVzMeta?.name ?? "gifts-uuid",
    path: _91uuid_937xTkGSzaVzMeta?.path ?? "/gifts/:uuid()",
    meta: _91uuid_937xTkGSzaVzMeta || {},
    alias: _91uuid_937xTkGSzaVzMeta?.alias || [],
    redirect: _91uuid_937xTkGSzaVzMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/gifts/[uuid].vue").then(m => m.default || m)
  },
  {
    name: indexM8sKxDRuhIMeta?.name ?? "gifts",
    path: indexM8sKxDRuhIMeta?.path ?? "/gifts",
    meta: indexM8sKxDRuhIMeta || {},
    alias: indexM8sKxDRuhIMeta?.alias || [],
    redirect: indexM8sKxDRuhIMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/gifts/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_id_93xkmpdqdsLeMeta?.name ?? "gifts-invitation-invitation_id",
    path: _91invitation_id_93xkmpdqdsLeMeta?.path ?? "/gifts/invitation/:invitation_id()",
    meta: _91invitation_id_93xkmpdqdsLeMeta || {},
    alias: _91invitation_id_93xkmpdqdsLeMeta?.alias || [],
    redirect: _91invitation_id_93xkmpdqdsLeMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/gifts/invitation/[invitation_id].vue").then(m => m.default || m)
  },
  {
    name: _91product_id_93gKYlISYQrQMeta?.name ?? "gifts-product-product_id",
    path: _91product_id_93gKYlISYQrQMeta?.path ?? "/gifts/product/:product_id()",
    meta: _91product_id_93gKYlISYQrQMeta || {},
    alias: _91product_id_93gKYlISYQrQMeta?.alias || [],
    redirect: _91product_id_93gKYlISYQrQMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/gifts/product/[product_id].vue").then(m => m.default || m)
  },
  {
    name: indexTkqcjnIFITMeta?.name ?? "index",
    path: indexTkqcjnIFITMeta?.path ?? "/",
    meta: indexTkqcjnIFITMeta || {},
    alias: indexTkqcjnIFITMeta?.alias || [],
    redirect: indexTkqcjnIFITMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_unique_id_93S0jMQ8CMWFMeta?.name ?? "invitation-invitation_unique_id",
    path: _91invitation_unique_id_93S0jMQ8CMWFMeta?.path ?? "/invitation/:invitation_unique_id()",
    meta: _91invitation_unique_id_93S0jMQ8CMWFMeta || {},
    alias: _91invitation_unique_id_93S0jMQ8CMWFMeta?.alias || [],
    redirect: _91invitation_unique_id_93S0jMQ8CMWFMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/invitation/[invitation_unique_id].vue").then(m => m.default || m)
  },
  {
    name: jointhIZfvlFToMeta?.name ?? "join",
    path: jointhIZfvlFToMeta?.path ?? "/join",
    meta: jointhIZfvlFToMeta || {},
    alias: jointhIZfvlFToMeta?.alias || [],
    redirect: jointhIZfvlFToMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/join.vue").then(m => m.default || m)
  },
  {
    name: login0jfX7z218ZMeta?.name ?? "login",
    path: login0jfX7z218ZMeta?.path ?? "/login",
    meta: login0jfX7z218ZMeta || {},
    alias: login0jfX7z218ZMeta?.alias || [],
    redirect: login0jfX7z218ZMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/login.vue").then(m => m.default || m)
  },
  {
    name: logoutuflFQqDTObMeta?.name ?? "logout",
    path: logoutuflFQqDTObMeta?.path ?? "/logout",
    meta: logoutuflFQqDTObMeta || {},
    alias: logoutuflFQqDTObMeta?.alias || [],
    redirect: logoutuflFQqDTObMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/logout.vue").then(m => m.default || m)
  },
  {
    name: _91meeting_type_slug_93rIBVUyjY81Meta?.name ?? "meet-meeting_type_slug",
    path: _91meeting_type_slug_93rIBVUyjY81Meta?.path ?? "/meet/:meeting_type_slug()",
    meta: _91meeting_type_slug_93rIBVUyjY81Meta || {},
    alias: _91meeting_type_slug_93rIBVUyjY81Meta?.alias || [],
    redirect: _91meeting_type_slug_93rIBVUyjY81Meta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/meet/[meeting_type_slug].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93o5Ivt80scyMeta?.name ?? "meet-meeting_unique_id",
    path: _91meeting_unique_id_93o5Ivt80scyMeta?.path ?? "/meet/:meeting_unique_id()",
    meta: _91meeting_unique_id_93o5Ivt80scyMeta || {},
    alias: _91meeting_unique_id_93o5Ivt80scyMeta?.alias || [],
    redirect: _91meeting_unique_id_93o5Ivt80scyMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/meet/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93qOCA07HOi9Meta?.name ?? "meeting-meeting_unique_id",
    path: _91meeting_unique_id_93qOCA07HOi9Meta?.path ?? "/meeting/:meeting_unique_id()",
    meta: _91meeting_unique_id_93qOCA07HOi9Meta || {},
    alias: _91meeting_unique_id_93qOCA07HOi9Meta?.alias || [],
    redirect: _91meeting_unique_id_93qOCA07HOi9Meta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/meeting/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: my_45favoritestaZ5Fon6RfMeta?.name ?? "my-favorites",
    path: my_45favoritestaZ5Fon6RfMeta?.path ?? "/my-favorites",
    meta: my_45favoritestaZ5Fon6RfMeta || {},
    alias: my_45favoritestaZ5Fon6RfMeta?.alias || [],
    redirect: my_45favoritestaZ5Fon6RfMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/my-favorites.vue").then(m => m.default || m)
  },
  {
    name: my_45studios2gnOwCjDO1Meta?.name ?? "my-studios",
    path: my_45studios2gnOwCjDO1Meta?.path ?? "/my-studios",
    meta: my_45studios2gnOwCjDO1Meta || {},
    alias: my_45studios2gnOwCjDO1Meta?.alias || [],
    redirect: my_45studios2gnOwCjDO1Meta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/my-studios.vue").then(m => m.default || m)
  },
  {
    name: optindDk4frOM3oMeta?.name ?? "optin",
    path: optindDk4frOM3oMeta?.path ?? "/optin",
    meta: optindDk4frOM3oMeta || {},
    alias: optindDk4frOM3oMeta?.alias || [],
    redirect: optindDk4frOM3oMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/optin.vue").then(m => m.default || m)
  },
  {
    name: _91episode_id_93lbkf0yt0Y4Meta?.name ?? "podcasts-podcast_id-episodes-episode_id",
    path: _91episode_id_93lbkf0yt0Y4Meta?.path ?? "/podcasts/:podcast_id()/episodes/:episode_id()",
    meta: _91episode_id_93lbkf0yt0Y4Meta || {},
    alias: _91episode_id_93lbkf0yt0Y4Meta?.alias || [],
    redirect: _91episode_id_93lbkf0yt0Y4Meta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue").then(m => m.default || m)
  },
  {
    name: indexZToqwTH4fUMeta?.name ?? "podcasts-podcast_id",
    path: indexZToqwTH4fUMeta?.path ?? "/podcasts/:podcast_id()",
    meta: indexZToqwTH4fUMeta || {},
    alias: indexZToqwTH4fUMeta?.alias || [],
    redirect: indexZToqwTH4fUMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/podcasts/[podcast_id]/index.vue").then(m => m.default || m)
  },
  {
    name: indexOFJrtRce57Meta?.name ?? "podcasts",
    path: indexOFJrtRce57Meta?.path ?? "/podcasts",
    meta: indexOFJrtRce57Meta || {},
    alias: indexOFJrtRce57Meta?.alias || [],
    redirect: indexOFJrtRce57Meta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/podcasts/index.vue").then(m => m.default || m)
  },
  {
    name: _91product_id_93FIv2MB8KHOMeta?.name ?? "product-product_id",
    path: _91product_id_93FIv2MB8KHOMeta?.path ?? "/product/:product_id()",
    meta: _91product_id_93FIv2MB8KHOMeta || {},
    alias: _91product_id_93FIv2MB8KHOMeta?.alias || [],
    redirect: _91product_id_93FIv2MB8KHOMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutPXwGvGGbkLMeta?.name ?? "product-product_id-about",
    path: aboutPXwGvGGbkLMeta?.path ?? "about",
    meta: aboutPXwGvGGbkLMeta || {},
    alias: aboutPXwGvGGbkLMeta?.alias || [],
    redirect: aboutPXwGvGGbkLMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: digital_45download_45contentGntyhLgZMtMeta?.name ?? "product-product_id-digital-download-content",
    path: digital_45download_45contentGntyhLgZMtMeta?.path ?? "digital-download-content",
    meta: digital_45download_45contentGntyhLgZMtMeta || {},
    alias: digital_45download_45contentGntyhLgZMtMeta?.alias || [],
    redirect: digital_45download_45contentGntyhLgZMtMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/product/[product_id]/digital-download-content.vue").then(m => m.default || m)
  },
  {
    name: eventskDb9e4c5MoMeta?.name ?? "product-product_id-events",
    path: eventskDb9e4c5MoMeta?.path ?? "events",
    meta: eventskDb9e4c5MoMeta || {},
    alias: eventskDb9e4c5MoMeta?.alias || [],
    redirect: eventskDb9e4c5MoMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93GvcxzlqaHLMeta?.name ?? "product-product_id-free-media-media_id",
    path: _91media_id_93GvcxzlqaHLMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93GvcxzlqaHLMeta || {},
    alias: _91media_id_93GvcxzlqaHLMeta?.alias || [],
    redirect: _91media_id_93GvcxzlqaHLMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45samplePMiDqn6KHEMeta?.name ?? "product-product_id-free-sample",
    path: free_45samplePMiDqn6KHEMeta?.path ?? "free-sample",
    meta: free_45samplePMiDqn6KHEMeta || {},
    alias: free_45samplePMiDqn6KHEMeta?.alias || [],
    redirect: free_45samplePMiDqn6KHEMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productsB4OB4d1oRaMeta?.name ?? "product-product_id-included-products",
    path: included_45productsB4OB4d1oRaMeta?.path ?? "included-products",
    meta: included_45productsB4OB4d1oRaMeta || {},
    alias: included_45productsB4OB4d1oRaMeta?.alias || [],
    redirect: included_45productsB4OB4d1oRaMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93UJ6B4ypE9EMeta?.name ?? "product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93UJ6B4ypE9EMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93UJ6B4ypE9EMeta || {},
    alias: _91media_id_93UJ6B4ypE9EMeta?.alias || [],
    redirect: _91media_id_93UJ6B4ypE9EMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: viewkyMsNf5sZiMeta?.name ?? "product-product_id-lessons-lesson_id-view",
    path: viewkyMsNf5sZiMeta?.path ?? "lessons/:lesson_id()/view",
    meta: viewkyMsNf5sZiMeta || {},
    alias: viewkyMsNf5sZiMeta?.alias || [],
    redirect: viewkyMsNf5sZiMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: indexNIHAoAntPKMeta?.name ?? "product-product_id-lessons",
    path: indexNIHAoAntPKMeta?.path ?? "lessons",
    meta: indexNIHAoAntPKMeta || {},
    alias: indexNIHAoAntPKMeta?.alias || [],
    redirect: indexNIHAoAntPKMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_932tqWuG1IrfMeta?.name ?? "product-product_id-media-media_id",
    path: _91media_id_932tqWuG1IrfMeta?.path ?? "media/:media_id()",
    meta: _91media_id_932tqWuG1IrfMeta || {},
    alias: _91media_id_932tqWuG1IrfMeta?.alias || [],
    redirect: _91media_id_932tqWuG1IrfMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexASy0KRozOcMeta?.name ?? "product-product_id-playlists-playlist_id",
    path: indexASy0KRozOcMeta?.path ?? "playlists/:playlist_id()",
    meta: indexASy0KRozOcMeta || {},
    alias: indexASy0KRozOcMeta?.alias || [],
    redirect: indexASy0KRozOcMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_937jhV6u2nXXMeta?.name ?? "product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_937jhV6u2nXXMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_937jhV6u2nXXMeta || {},
    alias: _91media_id_937jhV6u2nXXMeta?.alias || [],
    redirect: _91media_id_937jhV6u2nXXMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: index97zoCuOjT2Meta?.name ?? "product-product_id-playlists",
    path: index97zoCuOjT2Meta?.path ?? "playlists",
    meta: index97zoCuOjT2Meta || {},
    alias: index97zoCuOjT2Meta?.alias || [],
    redirect: index97zoCuOjT2Meta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionsnqJ32pSu2QMeta?.name ?? "product-product_id-private-sessions",
    path: private_45sessionsnqJ32pSu2QMeta?.path ?? "private-sessions",
    meta: private_45sessionsnqJ32pSu2QMeta || {},
    alias: private_45sessionsnqJ32pSu2QMeta?.alias || [],
    redirect: private_45sessionsnqJ32pSu2QMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordingsuBUJxJZv9xMeta?.name ?? "product-product_id-recordings",
    path: recordingsuBUJxJZv9xMeta?.path ?? "recordings",
    meta: recordingsuBUJxJZv9xMeta || {},
    alias: recordingsuBUJxJZv9xMeta?.alias || [],
    redirect: recordingsuBUJxJZv9xMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviewsYzbroVUc78Meta?.name ?? "product-product_id-reviews",
    path: reviewsYzbroVUc78Meta?.path ?? "reviews",
    meta: reviewsYzbroVUc78Meta || {},
    alias: reviewsYzbroVUc78Meta?.alias || [],
    redirect: reviewsYzbroVUc78Meta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexhxnHqJb2NlMeta?.name ?? "product",
    path: indexhxnHqJb2NlMeta?.path ?? "/product",
    meta: indexhxnHqJb2NlMeta || {},
    alias: indexhxnHqJb2NlMeta?.alias || [],
    redirect: indexhxnHqJb2NlMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/product/index.vue").then(m => m.default || m)
  },
  {
    name: indexd17aMwC1kwMeta?.name ?? "profile",
    path: indexd17aMwC1kwMeta?.path ?? "/profile",
    meta: indexd17aMwC1kwMeta || {},
    alias: indexd17aMwC1kwMeta?.alias || [],
    redirect: indexd17aMwC1kwMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/profile/index.vue").then(m => m.default || m)
  },
  {
    name: purchasesvludfOEvMhMeta?.name ?? "profile-purchases",
    path: purchasesvludfOEvMhMeta?.path ?? "/profile/purchases",
    meta: purchasesvludfOEvMhMeta || {},
    alias: purchasesvludfOEvMhMeta?.alias || [],
    redirect: purchasesvludfOEvMhMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/profile/purchases.vue").then(m => m.default || m)
  },
  {
    name: redemptions21Q7nH4Z3wMeta?.name ?? "profile-redemptions",
    path: redemptions21Q7nH4Z3wMeta?.path ?? "/profile/redemptions",
    meta: redemptions21Q7nH4Z3wMeta || {},
    alias: redemptions21Q7nH4Z3wMeta?.alias || [],
    redirect: redemptions21Q7nH4Z3wMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/profile/redemptions.vue").then(m => m.default || m)
  },
  {
    name: _91quiz_id_93RLeVdeUs6KMeta?.name ?? "quiz-quiz_id",
    path: _91quiz_id_93RLeVdeUs6KMeta?.path ?? "/quiz/:quiz_id()",
    meta: _91quiz_id_93RLeVdeUs6KMeta || {},
    alias: _91quiz_id_93RLeVdeUs6KMeta?.alias || [],
    redirect: _91quiz_id_93RLeVdeUs6KMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/quiz/[quiz_id].vue").then(m => m.default || m)
  },
  {
    name: _91token_93HVvdm1Lb0JMeta?.name ?? "reset-password-uid-token",
    path: _91token_93HVvdm1Lb0JMeta?.path ?? "/reset-password/:uid()/:token()",
    meta: _91token_93HVvdm1Lb0JMeta || {},
    alias: _91token_93HVvdm1Lb0JMeta?.alias || [],
    redirect: _91token_93HVvdm1Lb0JMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/reset-password/[uid]/[token].vue").then(m => m.default || m)
  },
  {
    name: resetXF04AmUbT4Meta?.name ?? "reset",
    path: resetXF04AmUbT4Meta?.path ?? "/reset",
    meta: resetXF04AmUbT4Meta || {},
    alias: resetXF04AmUbT4Meta?.alias || [],
    redirect: resetXF04AmUbT4Meta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/reset.vue").then(m => m.default || m)
  },
  {
    name: shopGoRKx11DJOMeta?.name ?? "shop",
    path: shopGoRKx11DJOMeta?.path ?? "/shop",
    meta: shopGoRKx11DJOMeta || {},
    alias: shopGoRKx11DJOMeta?.alias || [],
    redirect: shopGoRKx11DJOMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/shop.vue").then(m => m.default || m)
  },
  {
    name: signupPtfzKoRYGAMeta?.name ?? "signup",
    path: signupPtfzKoRYGAMeta?.path ?? "/signup",
    meta: signupPtfzKoRYGAMeta || {},
    alias: signupPtfzKoRYGAMeta?.alias || [],
    redirect: signupPtfzKoRYGAMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/signup.vue").then(m => m.default || m)
  },
  {
    name: livejL8wToAidkMeta?.name ?? "streaming-event_id-live",
    path: livejL8wToAidkMeta?.path ?? "/streaming/:event_id()/live",
    meta: livejL8wToAidkMeta || {},
    alias: livejL8wToAidkMeta?.alias || [],
    redirect: livejL8wToAidkMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/streaming/[event_id]/live.vue").then(m => m.default || m)
  },
  {
    name: tipsFjKnTlna3cMeta?.name ?? "tips",
    path: tipsFjKnTlna3cMeta?.path ?? "/tips",
    meta: tipsFjKnTlna3cMeta || {},
    alias: tipsFjKnTlna3cMeta?.alias || [],
    redirect: tipsFjKnTlna3cMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/tips.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_933HoC85NHt8Meta?.name ?? "waiver-uuid",
    path: _91uuid_933HoC85NHt8Meta?.path ?? "/waiver/:uuid()",
    meta: _91uuid_933HoC85NHt8Meta || {},
    alias: _91uuid_933HoC85NHt8Meta?.alias || [],
    redirect: _91uuid_933HoC85NHt8Meta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/waiver/[uuid].vue").then(m => m.default || m)
  },
  {
    name: compactRCI1dybz3sMeta?.name ?? "widgets-calendars-compact",
    path: compactRCI1dybz3sMeta?.path ?? "/widgets/calendars/compact",
    meta: compactRCI1dybz3sMeta || {},
    alias: compactRCI1dybz3sMeta?.alias || [],
    redirect: compactRCI1dybz3sMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/widgets/calendars/compact.vue").then(m => m.default || m)
  },
  {
    name: fullU6Wi9H9mtcMeta?.name ?? "widgets-calendars-full",
    path: fullU6Wi9H9mtcMeta?.path ?? "/widgets/calendars/full",
    meta: fullU6Wi9H9mtcMeta || {},
    alias: fullU6Wi9H9mtcMeta?.alias || [],
    redirect: fullU6Wi9H9mtcMeta?.redirect,
    component: () => import("/tmp/build_b474bb5e/pages/[studio_url]/widgets/calendars/full.vue").then(m => m.default || m)
  }
]